import * as React from 'react'
import { Connector, useConnect, useConnectors, useDisconnect, usePublicClient } from 'wagmi'
import { checkUserHaveNFT, updateUidAndAddress } from './function/13w'

export function WalletOptions() {
  const { connectAsync } = useConnect()
  const connectors = useConnectors()
  const { disconnect } = useDisconnect()

  const publicClient = usePublicClient()
  const uniqueConnectors = React.useMemo(
    () => connectors.filter((c, index, arr) => arr.findIndex(x => x.name === c.name) === index),
    [connectors]
  )

  function getUserId(): number {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObject = JSON.parse(userData)
      return userObject.id
    }
    return 0;
  }

  async function linkWallet(userId: number, account: string) {
    try {
      const linkwalletStatus = await updateUidAndAddress(String(userId), account as `0x${string}`)
      if (!linkwalletStatus) {
        disconnect()
      }
    } catch (err) {
      console.error('Error linking wallet:', err)
      disconnect()
    }
  }

  function getWalletIcon(walletName: string): string {
    const icons: { [key: string]: string } = {
      MetaMask: '/images/wallet/MetaMask-icon.svg',
      WalletConnect: '/images/wallet/Trust-Wallet.svg',
      'Coinbase Wallet': '/images/wallet/Coinbase.svg',
    };
    return icons[walletName] || '/images/wallet/Default-Wallet.svg';
  }
  const mapConnectors = uniqueConnectors.map((connector: any) => ({
    uid: connector.uid,
    icon: getWalletIcon(connector.name),
    connector: connector,
    onClick: async () => {
      try {
        const data = await connectAsync({ connector, chainId: 56 })
        const account = (data as any).account || (data as any).accounts?.[0]
        checkUserHaveNFT(publicClient, account).then(async (hasNFT) => {
          if (hasNFT) {
            const userId = getUserId()
            if (account && userId) {
              await linkWallet(userId, account)
            }
          }
        })
        // const account = (data as any).account || (data as any).accounts?.[0]
        // const userId = getUserId()
        // if (account && userId) {
        //   await linkWallet(userId, account)
        // } else {
        //   disconnect()
        // }
      } catch (error) {
        console.error('Error connecting to wallet:', error)
      }
    },
  }));

  return mapConnectors.map((connector) => (
    <WalletOption
      key={connector.uid}
      icon={connector.icon}
      connector={connector.connector}
      onClick={connector.onClick}
    />
  ))
}

function WalletOption({
  icon,
  connector,
  onClick,
}: {
  icon: string
  connector: Connector
  onClick: () => void
}) {
  const [ready, setReady] = React.useState(false)

  React.useEffect(() => {
    ; (async () => {
      const provider = await connector.getProvider()
      setReady(!!provider)
    })()
  }, [connector])

  return (
    <button disabled={!ready} onClick={onClick}
      className="flex flex-row justify-between items-center border !rounded-lg px-4 py-2 hover:!shadow-lg transition-shadow duration-200 ease-in-out"
      style={{ margin: '0.5rem', padding: '0.5rem', cursor: ready ? 'pointer' : 'not-allowed' }}
    >
      <img src={icon} alt={`${connector.name} icon`} style={{ width: '24px', height: '24px', marginRight: '8px' }} />
      {connector.name}
    </button>
  )
}